import { Outlet, createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const search = z.object({
  return_to: z.string().optional(),
  mfa: z.enum(['required']).optional(),
  mfa_enrollment_required: z.coerce.boolean().optional(),
});

export const Route = createFileRoute('/login')({
  validateSearch: search,
  component: LoginLayout,
});

function LoginLayout() {
  return <Outlet />;
}
